import React, { useState, useEffect, useRef } from "react";
import { Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setPlaceAPIToken } from "../../Redux/AuthSlice";
import { getPlaceList } from "../../Services/destination";


const DebouncedSelect = ({
  value,
  onChange,
  placeholder = "Type to search...",
  minLength = 4,
  delay = 500,
}) => {
  const [options, setOptions] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const timeoutRef = useRef();

  const dispatch = useDispatch();
    const placeAPIToken = useSelector((state) => state.authTracking.place_API_token);

  const handleSearch = (input) => {
    setInputValue(input)
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (input.length < minLength) {
      setOptions([]);
      return;
    }

    timeoutRef.current = setTimeout(async () => {
      setFetching(true);

      const payload = {
        input_text: input,
        session_token: placeAPIToken || "",
      };

      const response = await getPlaceList(payload);

      if (response?.session_token) {
        dispatch(setPlaceAPIToken(response.session_token));
      }

      const mappedOptions = response?.place_data?.map((item) => ({
        value: item?.text,
        label: item?.text,
      })) || [];

      setOptions(mappedOptions);
      setFetching(false);
    }, delay);
  };

  useEffect(() => {
    return () => clearTimeout(timeoutRef.current);
  }, []);

  return (
    <Select
      showSearch
      allowClear
      value={value}
      placeholder={placeholder}
      onSearch={handleSearch}
      onChange={onChange}
      filterOption={false}
      options={options}
      loading={fetching}
      notFoundContent={
        fetching ? (
          <div className="flex justify-center items-center h-full">
            <Spin size="small" />
          </div>
        ) : (
          <>{inputValue?.length < 4 || fetching ? placeholder: "No data"}</>
        )
      }
    />
  );
};

export default DebouncedSelect;
